import { buildShopSearchForm } from '@pcln/home-components'
import { formatDate } from './date-helper'
import getComponentsFromTripType from './get-components-from-triptypes'

const packagesSearch = ({
  roomCount = 1,
  adultCount = 2,
  childrenCount = 0,
  childrenAges = [],
  startDate = '',
  endDate = '',
  startLocationObject = undefined,
  endLocationObject = undefined,
  hotelStartDate = '',
  hotelEndDate = '',
  tripType = 'STAY:FLY',
  isPartialStayDateValid,
  isRecommendedTrip = false,
  includeBasicEconomy = true,
  ...rest
}) => {
  const url = '/shop/search/'
  const childrenAgesMock = {}
  if (childrenCount > 0) {
    childrenAges.forEach((item, i) => {
      const index = i + 1
      const key = `child${index}`
      childrenAgesMock[key] = item
    })
  }

  const searchRequest = {
    rooms: roomCount,
    adultCount,
    childCount: childrenCount,
    children: childrenAgesMock,
    departureDate: formatDate(startDate),
    departureLocation: startLocationObject || endLocationObject,
    returnDate: formatDate(endDate),
    arrivalLocation: endLocationObject,
    pivotComponentKey: 0,
    isRecommendedTrip,
    components: getComponentsFromTripType(tripType, {
      isPartialStayDateValid,
      includeBasicEconomy,
      hotelStartDate: formatDate(hotelStartDate, 'yyyy-MM-dd'),
      hotelEndDate: formatDate(hotelEndDate, 'yyyy-MM-dd'),
      roomCount,
      isCarRequired: tripType.includes('DRIVE'),
      ...rest
    })
  }

  const form = buildShopSearchForm(url, searchRequest)
  form.submit()
}

export default packagesSearch
